import "./ManageLayers.scss";
import { OptionCard } from "../optionCard/optionCard";
import { CloudUploadIcon } from "../../assets/icons/cloudUploadIcon";
import { DeleteIcon } from "../../assets/icons/deleteIcon";
import { EditIcon } from "../../assets/icons/editIcon";

export const ManageLayers = ({ onCrossClick, onMinimizeClick, onDeleteClick = ()=>{}, onUploadFile = ()=>{}, onEditLayers = ()=>{} }) => {
  const handleOnCrossClick = () => {
    onCrossClick && onCrossClick();
  };
  const handleOnMinimizeClick = () => {
    onMinimizeClick && onMinimizeClick();
  };
  // const handleOnCloudFileUpload = (e) => {};
  return (
    <OptionCard
      className="create-layer-container"
      onCrossClick={handleOnCrossClick}
      onMinimizeClick={handleOnMinimizeClick}
      title="Crea nuovo Layer"
    >
      <div className="create-layer-option-body-container">
        <div className="upload-shape-file-container" onClick={onUploadFile}>
          <label htmlFor="upload-shape-file" className="upload-shape-file">
            <CloudUploadIcon fillColor="var(--archeo-color)"/>
            <span className="upload-shape-file-text">Carica Shapefile</span>
          </label>
        </div>
        <div className="upload-shape-file-container" onClick={onEditLayers}>
          <label htmlFor="edit-layers" className="edit-layers">
            <EditIcon fillColor="var(--archeo-color)"/>
            <span className="edit-layers-text">Edita i layer</span>
          </label>
        </div>
        <div className="delete-shape-file-container" onClick={onDeleteClick}>
          <DeleteIcon fillColor="var(--archeo-color)"/>
          <span className="delete-shape-file-container">Cancella layer</span>
        </div>
      </div>
    </OptionCard>
  );
};
